<template>
<div id="dashboard">
  <div id="dashboard-header">
    <v-btn flat dark :to="`/bot/${activeBot.code}`" class="report-back-btn text-capitalize">
      <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
      back
    </v-btn>
    <span id="dashboard-header-title">{{$t('dashboardRealtime')|capitalize}}</span>
    <div id="dashboard-header-bot-list">
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <div v-on="on" id="dashboard-header-active-bot">
            <span>{{ activeBot ? activeBot.name : '' }}</span>
            <v-icon color="#fff">mdi-chevron-down</v-icon>
          </div>
        </template>
        <div id="dashboard-header-bot-list-menu">
          <v-list>
            <v-list-tile
                v-for="bot in botList"
                :key="bot.code"
                @click="onChangeBot(bot)"
                :class="activeBot.code === bot.code ? 'active' : ''"
            >
              <v-list-tile-title>{{bot.name}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </div>
      </v-menu>
    </div>
  </div>
  <div id="dashboard-content">
    <ConcurrentAgent/>
    <ConcurrentSession/>
    <ConcurrentCustomer/>
    <ConcurrentTicket/>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";
import StaffService from "@/services/staff.service";
import _ from "lodash";
import ConcurrentAgent from "@/views/dashboard-realtime/ConcurrentAgent";
import ConcurrentSession from "@/views/dashboard-realtime/ConcurrentSession";
import ConcurrentCustomer from "@/views/dashboard-realtime/ConcurrentCustomer";
import ConcurrentTicket from "@/views/dashboard-realtime/ConcurrentTicket";
import {SocketMixin} from "@/mixins/SocketMixin";
import ActionTypes from "@/store/ActionTypes";

export default {
  name: "DashBoardRealtime",
  components: {ConcurrentTicket, ConcurrentCustomer, ConcurrentSession, ConcurrentAgent},
  mixins: [SocketMixin],
  data() {
    return {
      loadingDialog: false,
    }
  },
  mounted() {
    if(this.hasPermission() && this.botConfig['enableOverviewDashboardRealtime']){
      this.loadingDialog = true;
      this.initBotStaffList();
    }
    else {
      this.$router.push('/forbidden')
    }
  
  },
  computed: {
    ...mapState(['botStaffList', 'user']),
    ...mapState('config', ['botConfig']),

    hasAdminRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9])
    },
    hasManageRole() {
      return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5])
    },
    activeBot() {
      const botCode = this.$route.params.bot_code;
      if (botCode) {
        let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
        return bot ? {code: bot.bot_code, name: bot.bot_name} : {}
      }
      return {}
    },
    botList() {
      return _.map(this.botStaffList, o => {
        return {name: o.bot_name, code: o.bot_code}
      });
    }
  },
  methods: {
    hasPermission() {
      return StaffService.checkStaffHasRole(this.$route.params.bot_code, this.user.id, [10, 9, 5])
    },
    onChangeBot(bot) {
      if (this.activeBot.code !== bot.code) {
        // this.$store.commit(ActionTypes.BOT, bot)
        this.$router.push('/dashboard-realtime/' + bot.code)
        this.$router.go(0)
      }
    },
    initBotStaffList() {
      if(this.botStaffList.length < 1) {
        this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "components/style/dashboard";
</style>
